import React, { ReactElement } from 'react';
import { PopoverAlign, Popover as TinyPopover } from 'react-tiny-popover';
import './Popover.css';
import { createPortal } from 'react-dom';

interface PopoverProps {
  isOpen: boolean;
  onClickOutside: (e: MouseEvent) => void;
  children: ReactElement;
  content: ReactElement;
  showBackdrop?: boolean;
  className?: string;
  align?: PopoverAlign;
  style?: any;
}

const Popover = ({
  isOpen,
  onClickOutside,
  children,
  content,
  showBackdrop = false,
  className,
  align,
  style,
}: PopoverProps) => (
  <>
    {showBackdrop &&
      isOpen &&
      createPortal(<div className="popover-backdrop"></div>, document.body)}
    <TinyPopover
      isOpen={isOpen}
      positions="bottom"
      onClickOutside={onClickOutside}
      containerClassName={className}
      content={<div className="popover">{content}</div>}
      align={align}
      containerStyle={style}
    >
      {children}
    </TinyPopover>
  </>
);

export default Popover;
